import { Injectable } from '@angular/core';
import { HttpRequestSettings, apis, controllerTypes } from '@sb-shared/models/request-settings';
import { HttpWebApiService } from '@sb-shared/services/http-web-api.service';
import { Observable } from 'rxjs';
import { VectareConfiguration, VectareConfigurationUpdateRequest } from '../models/vectare-configuration.model';

@Injectable({
  providedIn: 'root'
})
export class VectareTransportService {
  private readonly baseUrl = 'VectareTransport';

  constructor(private http: HttpWebApiService) {}

  getConfiguration(organisationId: number): Observable<VectareConfiguration> {
    return this.http.get(this.baseUrl, this.settings(organisationId));
  }

  saveConfiguration(
    organisationId: number,
    request: VectareConfigurationUpdateRequest
  ): Observable<VectareConfiguration> {
    return this.http.post(this.baseUrl, request, {
      ...this.settings(organisationId),
      showSuccessToast: false
    });
  }

  requestSync(organisationId: number): Observable<boolean> {
    return this.http.post(`${this.baseUrl}/Sync`, {}, {
      ...this.settings(organisationId),
      showSuccessToast: false
    });
  }

  // SysAdmin controllers take the organisation as a query parameter rather than in the route.
  //
  // `organisationId` is set explicitly rather than relying on HttpRequestSettings.orgId:
  // HttpWebApiService builds its request config (capturing settings.params) *before* calling
  // formatUrl, which is where orgId gets copied into params. When params starts out undefined,
  // formatUrl assigns a new object that the already-built config does not reference, so the
  // parameter never reaches the request and the API rejects it as a missing required value.
  private settings(organisationId: number): HttpRequestSettings {
    return {
      api: apis.Core,
      controllerType: controllerTypes.SysAdmin,
      params: { organisationId }
    };
  }
}
